"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBackAccountDto = instanceOfBackAccountDto;
exports.BackAccountDtoFromJSON = BackAccountDtoFromJSON;
exports.BackAccountDtoFromJSONTyped = BackAccountDtoFromJSONTyped;
exports.BackAccountDtoToJSON = BackAccountDtoToJSON;
exports.BackAccountDtoToJSONTyped = BackAccountDtoToJSONTyped;
/**
 * Check if a given object implements the BackAccountDto interface.
 */
function instanceOfBackAccountDto(value) {
    if (!('accountName' in value) || value['accountName'] === undefined)
        return false;
    if (!('bsb' in value) || value['bsb'] === undefined)
        return false;
    if (!('accountNumber' in value) || value['accountNumber'] === undefined)
        return false;
    if (!('bankName' in value) || value['bankName'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('listingId' in value) || value['listingId'] === undefined)
        return false;
    return true;
}
function BackAccountDtoFromJSON(json) {
    return BackAccountDtoFromJSONTyped(json, false);
}
function BackAccountDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'accountName': json['accountName'],
        'bsb': json['bsb'],
        'accountNumber': json['accountNumber'],
        'bankName': json['bankName'],
        'id': json['id'],
        'listingId': json['listingId'],
    };
}
function BackAccountDtoToJSON(json) {
    return BackAccountDtoToJSONTyped(json, false);
}
function BackAccountDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'accountName': value['accountName'],
        'bsb': value['bsb'],
        'accountNumber': value['accountNumber'],
        'bankName': value['bankName'],
        'id': value['id'],
        'listingId': value['listingId'],
    };
}
